// Desabilitar service workers em desenvolvimento
if (process.env.NODE_ENV === "development") {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }
}

// Links com barra repetida (ex.: e-mails antigos "https://portal//reset-password?token=...") abriam página em branco
if (/\/{2,}/.test(window.location.pathname)) {
  const corrigido = window.location.pathname.replace(/\/{2,}/g, "/");
  window.history.replaceState(null, "", corrigido + window.location.search + window.location.hash);
}

const path = (window.location.pathname || "/").replace(/\/$/, "") || "/";

if (path === "/tv") {
  import("./bootstrapTv").catch(() => {
    const el = document.getElementById("root");
    if (!el) return;
    el.innerHTML =
      '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:32px;font-family:Arial,sans-serif;text-align:center;background:#111">' +
      '<div><p style="color:#fff;font-size:20px;font-weight:700;margin:0 0 8px">Não foi possível abrir os anúncios</p>' +
      '<p style="color:#9ca3af;font-size:14px;margin:0;max-width:380px;line-height:1.5">Atualize esta página ou use o Chrome da TV, se disponível.</p></div></div>';
  });
} else {
  import("./bootstrapPortal");
}
